const PRIVACY_TRIGGER_SELECTOR = '[data-paramount-cmp-open]';

const runKetchCommand = (command) => {
  if (typeof window.ketch !== 'function') {
    return false;
  }

  try {
    const result = window.ketch(command);
    // Some CMP commands fail asynchronously; only treat explicit false as failure.
    return result !== false;
  } catch (error) {
    return false;
  }
};

const tryOpenCmpNow = () => {
  if (window.cbsoptanon && typeof window.cbsoptanon.showPreferences === 'function') {
    window.cbsoptanon.showPreferences();
    return true;
  }

  if (window.cbsoptanon && typeof window.cbsoptanon.ToggleInfoDisplay === 'function') {
    window.cbsoptanon.ToggleInfoDisplay();
    return true;
  }

  if (typeof window.Optanon !== 'undefined' && typeof window.Optanon.ToggleInfoDisplay === 'function') {
    window.Optanon.ToggleInfoDisplay();
    return true;
  }

  if (typeof window.OneTrust !== 'undefined' && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
    window.OneTrust.ToggleInfoDisplay();
    return true;
  }

  if (runKetchCommand('showPreferences')) {
    return true;
  }

  // Some Ketch integrations expose a direct API object.
  const ketchApi = window.Ketch || window.ketchApi;
  if (ketchApi && typeof ketchApi.showPreferences === 'function') {
    ketchApi.showPreferences();
    return true;
  }

  return false;
};

const openParamountCmp = () => {
  if (tryOpenCmpNow()) {
    return;
  }

  // Queue the open action for when the Paramount CMP shim finishes wiring APIs.
  if (window.cbsoptanon && Array.isArray(window.cbsoptanon.cmd)) {
    window.cbsoptanon.cmd.push(() => {
      tryOpenCmpNow();
    });
    return;
  }

  // If CMP scripts are still initializing, queue opening once scripts are ready.
  if (window.cbsoptanon && typeof window.cbsoptanon.onScriptsReady === 'function') {
    window.cbsoptanon.onScriptsReady(() => {
      tryOpenCmpNow();
    });
    return;
  }

  console.warn('Paramount CMP is not ready yet.');
};

const initPrivacyChoicesTrigger = () => {
  const triggers = Array.from(document.querySelectorAll(PRIVACY_TRIGGER_SELECTOR));

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openParamountCmp();
    });
  });
};

document.addEventListener('DOMContentLoaded', initPrivacyChoicesTrigger);
